export default class CheckboxControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.id = window.PRIM.getUUID()
    this.input.checked = args.value ? true : false
    this.input.type = 'checkbox'
    this.input.disabled = args.readonly ? 'disabled' : ''
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.input)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.checked
  }

  setValue (value) {
    this.input.checked = value ? true : false
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/CheckboxControl.js